import { toast } from 'react-toastify';

const toastConfig = {
  autoClose: 8000,
  draggablePercent: 20
};

const success = message => toast.success(message, toastConfig);
const error = message => toast.error(message, toastConfig);
const info = message => toast.info(message, toastConfig);

export default {
  success,
  error,
  info
};



// WEBPACK FOOTER //
// ./src/services/ToastService.js